import * as angular from 'angular';

import { ImportedTagDefinition, Group, Identifier, GroupDto, GroupFromTags } from '../../models';
import { IdentifierType } from '../../models/enum';
import { guidEmpty } from '../../common/constants';
import { ITagDefinitionService, ItagsImportService, IGroupService } from './';

export interface ItagsMappingService {
    addTagToGroup(importedTag: ImportedTagDefinition, group: Group, extraAliases: any[]): angular.IPromise<Group>;
    addTagsToGroup(importedTags: ImportedTagDefinition[], group: Group, extraAliases: any[], type: IdentifierType): angular.IPromise<GroupDto>;
    mapTagToIdentifier(importedTag: ImportedTagDefinition, identifier: Identifier, extraAliases: any[]): angular.IPromise<any>;
}

export class TagsMappingService implements ItagsMappingService {
    static serviceId = 'tagsMappingService';

    static $inject = [
        '$q',
        'tagsImportService',
        'groupService',
        'tagDefinitionService'
    ];

    constructor(
        private _$q: angular.IQService,
        private _tagsImportService: ItagsImportService,
        private _groupService: IGroupService,
        private _tagDefintionService: ITagDefinitionService
    ) {
    }

    addTagToGroup(importedTag: ImportedTagDefinition, group: Group, extraAliases: any[]): angular.IPromise<Group> {
        const dfd = this._$q.defer<Group>();
        if (importedTag.isAlreadyExisting) {
            const groupFromTags: GroupFromTags = { guid: group.guid, tags: [importedTag.guid] };
            this._groupService
                .createGroupFromTags(groupFromTags)
                .then((d) => {
                    if (d) {
                        dfd.resolve(d.group);
                    }
                })
                .catch(() => dfd.reject());
        } else {
            this._tagsImportService
                .import(importedTag, extraAliases)
                .then(d => {
                    if (group && group.guid !== guidEmpty) {
                        return this._groupService.createGroupFromTags({
                            guid: group.guid,
                            tags: [importedTag.guid]
                        });
                    }
                })
                .then((d) => {
                    if (d) {
                        dfd.resolve(d.group);
                    }
                })
                .catch(() => dfd.reject());
        }
        return dfd.promise;
    }

    addTagsToGroup(importedTags: ImportedTagDefinition[], group: Group, extraAliases: any[], type: IdentifierType): angular.IPromise<GroupDto> {
        const toAdd = importedTags.filter(d => !d.isAlreadyExisting);
        return this._tagsImportService
            .importAll(extraAliases, toAdd)
            .then((data: any) => {
                if (group && group.guid !== guidEmpty) {
                    return this._groupService.createGroupFromTags({
                        guid: group.guid,
                        tags: importedTags.map(t => t.guid),
                        type: type
                    });
                }
                return { group } as GroupDto;
            });
    }

    mapTagToIdentifier(importedTag: ImportedTagDefinition,
        identifier: Identifier,
        extraAliases: any[]): angular.IPromise<any> {
        const defered = this._$q.defer();
        if (importedTag.isAlreadyExisting) {
            this.validateMapping(importedTag.guid, identifier)
                .then(data => defered.resolve(data))
                .catch(() => defered.reject());
        } else {
            //TODO units validation
            this._tagsImportService.import(importedTag, extraAliases)
                .then(data => this.validateMapping(importedTag.guid, identifier))
                .then(data => defered.resolve(data))
                .catch(() => defered.reject());
        }
        return defered.promise;
    }

    private validateMapping(tagDefinitionGuid: string, identifier: Identifier): angular.IPromise<any> {
        const defered = this._$q.defer();
        const result = {
            identifier: angular.copy(identifier),
            isVariableTypeOk: false,
            isTagOk: false
        };
        this._tagDefintionService
            .getByGuid(tagDefinitionGuid)
            .then(dto => {
                const tagDefinition = dto.tagDefinition;
                if (!identifier.tagDefinitionGuid || identifier.tagDefinitionGuid === guidEmpty) {
                    result.isTagOk = true;
                } else {
                    result.isTagOk = false;
                }
                if (identifier.variableTypeGuid === tagDefinition.variableTypeGuid) {
                    result.isVariableTypeOk = true;
                }
                result.identifier.tagDefinitionGuid = tagDefinition.guid;
                defered.resolve(result);
            })
            .catch(() => defered.reject());
        return defered.promise;
    }
}